<div class="container">
  <lib-calendar-date-picker
    [formControl]="controlSelectedDateRange"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [isLoading]="isLoading"
  ></lib-calendar-date-picker>

  <ng-container *ngIf="availableSlotMatrix?.length > 0; else noSlotTemplate">
    <mat-grid-list cols="7" [rowHeight]="'50px'">
      <mat-grid-tile *ngFor="let myCustomSlot of availableSlotMatrix[0]">
        <div class="week-day-label">
          <div>{{ myCustomSlot.slot | weekdayFormatter : true }}</div>
          <div>{{ myCustomSlot.slot | dateFormatter : true }}</div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>

    <lib-spacer [height]="5"></lib-spacer>
    <lib-divider></lib-divider>
    <lib-spacer [height]="5"></lib-spacer>

    <ng-container *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <lib-spacer [height]="10"></lib-spacer>
    </ng-container>

    <div
      [id]="SCROLLING_SLOT_CONTAINER_ID"
      class="scrolling-time-slot-container"
    >
      <mat-grid-list cols="7" [rowHeight]="'40px'">
        <ng-container *ngFor="let slotRow of availableSlotMatrix">
          <mat-grid-tile
            *ngFor="let myCustomSlot of slotRow"
            [id]="generateHtmlIdForSlot(myCustomSlot.slot)"
          >
            <div class="time-slot-wrapper">
              <lib-calendar-slot-button
                [slot]="myCustomSlot.slot"
                [isSelected]="
                  myCustomSlot.isAvailable
                    ? isSlotSelected(myCustomSlot.slot)
                    : false
                "
                [disabled]="disabled || isLoading"
                [textOnly]="!myCustomSlot.isAvailable"
                [includeDiscount]="
                  myCustomSlot.isAvailable
                    ? isAnyDiscountInSlot(myCustomSlot.slot)
                    : false
                "
                (clicked)="selectSlotChanged(myCustomSlot.slot)"
              ></lib-calendar-slot-button>
            </div>
          </mat-grid-tile>
        </ng-container>
      </mat-grid-list>
    </div>
  </ng-container>
</div>
<ng-template #noSlotTemplate>
  <lib-spacer></lib-spacer>

  <lib-info-box>
    <span>{{
      'lib_calendar.available-slot-selection-by-week.text.not-available'
        | translate
    }}</span>
  </lib-info-box>
</ng-template>
